import { render, staticRenderFns } from "./InventoryHead.vue?vue&type=template&id=d1451632&scoped=true"
import script from "./InventoryHead.vue?vue&type=script&lang=js"
export * from "./InventoryHead.vue?vue&type=script&lang=js"
import style0 from "./InventoryHead.vue?vue&type=style&index=0&id=d1451632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1451632",
  null
  
)

export default component.exports